import * as Yup from "yup";
import { validatePassword, validateEmail } from "../common";

export const loginSchema = Yup.object().shape({
  email: validateEmail,
  password: validatePassword,
});
